export const combineClasses = classes => classes.join(' ');
